module.exports = __webpack_public_path__ + "static/media/packages.25b173ff.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/packages.png
// module id = 609
// module chunks = 0